import PropTypes from 'prop-types'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import { SIZE, TYPE } from 'baseui/select'
import SDSelect from '@/shared/components/SDComponents/SDSelect/SDSelect'
import RequiredLabel from '@/shared/components/RequiredLabel/RequiredLabel'
import useAddressSelect from './useAddressSelect'

const AddressSelect = ({
  currentValue = {},
  onChange,
  disabled = false,
  placeholder,
  label,
  caption,
  error,
  required = false,
  id = 'address-select',
  noResultsMsg,
  ...otherProps
}) => {
  const {
    addressList,
    selectedValue,
    isLoading,
    handleInputChange,
    handleSelectionChange,
    getOptionLabel: getOptionLabelData,
    selectOverrides,
    t,
  } = useAddressSelect({
    onAddressChange: onChange,
    initialValue: currentValue,
  })

  const getOptionLabel = ({ option }) => (
    <div dangerouslySetInnerHTML={getOptionLabelData({ option })} />
  )

  const computedPlaceholder = placeholder || t('subscriptionForm:address_module.search_field', 'Search address')
  const computedNoResultsMsg = noResultsMsg || t('subscriptionForm:characteristics_module.address.no_results_msg', 'No results found')

  return (
    <SDFormControl
      plainLabel
      label={label && <RequiredLabel label={label} required={required} />}
      caption={caption}
      error={error}
    >
      <SDSelect
        id={id}
        isLoading={isLoading}
        value={selectedValue}
        options={addressList}
        onChange={handleSelectionChange}
        onInputChange={handleInputChange}
        getOptionLabel={getOptionLabel}
        disabled={disabled}
        placeholder={computedPlaceholder}
        clearable={true}
        searchable={true}
        filterOptions={options => options}
        type={TYPE.search}
        size={SIZE.default}
        overrides={selectOverrides}
        noResultsMsg={computedNoResultsMsg}
        error={error}
        {...otherProps}
      />
    </SDFormControl>
  )
}

AddressSelect.propTypes = {
  currentValue: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  caption: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  id: PropTypes.string,
  noResultsMsg: PropTypes.string,
}

export default AddressSelect
